// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons--pDFOBZbAad"};